import Step0GamingPlatform from './steps/Step0_GamingPlatform'
import Step1IntakeContact from './steps/Step1_IntakeContact'
import Step2InjuredParty from './steps/Step2_InjuredParty'
import Step3GamingDetails from './steps/Step3_GamingDetails'
import Step4HealthLegal from './steps/Step4_HealthLegal'
import Step5EmergencyNotes from './steps/Step5_EmergencyNotes'
import Step6IdentityPreview from './steps/Step6_IdentityPreview'
import Step7Submit from './steps/Step7_Submit'
import Step8Signature from './steps/Step8_Signature'
import Step9FollowUp from './steps/Step9_FollowUp'
import { GAMING_CAMPAIGN_NAME, GAMING_CAMPAIGN_TYPE } from './constants'
import type { CampaignRegistry } from '../campaignRegistry.types'

export const gamingComponents = {
  Step0_GamingPlatform: Step0GamingPlatform,
  Step1_IntakeContact: Step1IntakeContact,
  Step2_InjuredParty: Step2InjuredParty,
  Step3_GamingDetails: Step3GamingDetails,
  Step4_HealthLegal: Step4HealthLegal,
  Step5_EmergencyNotes: Step5EmergencyNotes,
  Step6_IdentityPreview: Step6IdentityPreview,
  Step7_Submit: Step7Submit,
  Step8_Signature: Step8Signature,
  Step9_FollowUp: Step9FollowUp,
  // Backwards compatibility with legacy component keys
  GamingPlatform: Step0GamingPlatform,
  IntakeContact: Step1IntakeContact,
  InjuredParty: Step2InjuredParty,
  GamingDetails: Step3GamingDetails,
  HealthLegal: Step4HealthLegal,
  EmergencyNotes: Step5EmergencyNotes,
  IdentityPreview: Step6IdentityPreview,
  Submit: Step7Submit,
  Signature: Step8Signature,
  FollowUp: Step9FollowUp,
}

export const gamingRegistry: CampaignRegistry = {
  type: GAMING_CAMPAIGN_TYPE,
  identifiers: [
    GAMING_CAMPAIGN_TYPE,
    GAMING_CAMPAIGN_NAME,
    'Gaming Addiction Campaign',
  ],
  stages: [], // Removed hardcoded stages - now loaded from database
  components: gamingComponents,
}

